<template>
  <BCard>
    <div class="text-black text-2xl font-medium mb-2">
      Data Kartu
    </div>
    <div class="flex gap-[7px] justify-end">
      <div class="flex items-center max-w-[250px] rounded-[8px] gap-[5px] px-[8px]  border-[1px] border-[#E2E2E2]">
        <span
          class="k-search-normal-1 font-bold  align-middle"
          style="font-size: 20px"
        />
        <BFormInput
          v-model="search"
          placeholder="Cari Card ID / 4 digit terakhir"
          class="border-0"
          @input="searchData"
        />
      </div>
      <BDropdown
        id="dropdown-1"
        no-caret
        variant="primary"
        right
        size="sm"
      >
        <template #button-content>
          <img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
            alt="filter"
          >
        </template>
        <div class="text-[#333333] my-1 font-semibold text-[14px] px-[10px] min-w-[250px]">
          Filter
        </div>
        <hr>
        <div class="x-[10px] my-1">
          <BDropdown
            id="dropdown_status_card"
            variant="none"
            toggle-class="toggle-form"
            class="w-full text-left mr-[100px]"
            left
            no-caret
            dropright
          >
            <template #button-content>
              <div class="text-left -ml-[10px] font-[400] text-[#333333]">
                Status Kartu
              </div>
            </template>
            <BDropdownForm>
              <BFormCheckbox
                v-for="(option, idx) in optionsStatus"
                :key="idx"
                v-model="status"
                :name="`checkbox-${idx}`"
                class="mx-[10px] my-[10px]"
                :value="option.value"
                @change="listCards()"
              >
                {{ option.text }}
              </BFormCheckbox>
            </BDropdownForm>
          </BDropdown>
        </div>
        <div class="x-[10px] my-1">
          <BDropdown
            id="dropdown_user_level"
            variant="none"
            toggle-class="toggle-form"
            class="w-full text-left mr-[100px]"
            left
            no-caret
            dropright
          >
            <template #button-content>
              <div class="text-left -ml-[10px] font-[400] text-[#333333]">
                Level User
              </div>
            </template>
            <BDropdownForm>
              <BFormCheckbox
                v-for="(option, idx) in optionsUserLevel"
                :key="idx"
                v-model="userLevel"
                :name="`checkbox-${idx}`"
                class="mx-[10px] my-[10px]"
                :value="option.value"
                @change="listCards()"
              >
                {{ option.text }}
              </BFormCheckbox>
            </BDropdownForm>
          </BDropdown>
        </div>
        <hr>
        <div class="px-[10px] my-1">
          <BButton
            variant="outline-primary"
            @click="onResetFilter"
          >
            Reset
          </BButton>
        </div>
      </BDropdown>
    </div>
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="table"
        class="mt-1"
        style="height: calc(100vh - 250px); overflow-y: scroll;"
        @scroll="onInfiniteScroll"
      >
        <BTable
          :items="items"
          :fields="fields"
          show-empty
          empty-text="Tidak ada data"
          hover
          selectable
          select-mode="single"
        >
          <template #cell(name)="data">
            <div class="flex items-start gap-8">
              <span
                v-b-tooltip.hover.top="`${data.item.level === 'platinum' ? 'Platinum' : data.item.level === 'gold' ? 'Gold' : 'Bronze'}`"
                class="k-card text-[20px]"
                :class="data.item.level === 'platinum'
                  ? 'text-[#757F9A]'
                  : data.item.level === 'gold'
                    ? 'text-[#F6B732]'
                    : 'text-[#CD7F32]'"
              />
              <div class="flex flex-col gap-4">
                <div class="text-[14px] gap-[4px] flex items-center">
                  <span class="text-[#333333] font-semibold text-nowrap capitalize">
                    {{ data.item.name }}
                  </span>
                  <div class="text-[#626262]">
                    {{ `***${data.item.last_number}` }}
                  </div>
                </div>
                <div class="flex items-center !gap-2">
                  <span class="text-[#828282]">Card id: {{ data.item.card_uuid.substring(0, 13) + "..." }}</span>
                  <img
                    src="https://storage.googleapis.com/komerce/assets/copy.svg"
                    width="20"
                    class="cursor-pointer"
                    @click="onCopy(data.item.card_uuid)"
                  >
                </div>
                <span class="text-[#333333] flex text-[14px] text-nowrap gap-[4px] items-center">
                  <div
                    class="h-[8px] w-[8px] rounded-full"
                    :class="mappingColor(data.item.status)"
                  />
                  <div>{{ mappingStatus(data.item.status) }}</div>
                </span>
              </div>
              <!-- <img
                v-if="data.item.labels"
                v-b-popover.hover.top="data.item.labels"
                src="https://storage.googleapis.com/komerce/assets/svg/button-cards.svg"
                alt="tag"
                width="20"
                class="cursor-pointer"
              > -->
            </div>
          </template>
          <template #cell(spending_category)="data">
            <span v-if="!isEmpty(data.item.spending_category)">
              <div
                v-for="(item, idx) in data.item.spending_category"
                :key="idx"
              >
                <span class="capitalize">{{ item.category }} ({{ item.percentage }}%)</span>
              </div>
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(more)="data">
            <div
              class="text-primary underline mt-1"
              @click="$router.push(`/komcards-data-partner/${data.item.user_id}?tab=cards`)"
            >
              Detail>>
            </div>
          </template>
        </BTable>

      </div>
    </BOverlay>
  </BCard>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import isEmpty from 'lodash/isEmpty'
import { columnConfig } from './config'

export default {
  data() {
    return {
      isEmpty,
      search: null,
      offset: 0,
      limit: 25,
      items: null,
      loading: false,
      fields: columnConfig,
      lastData: false,
      optionsStatus: [
        { value: 'active', text: 'Aktif' },
        { value: 'inactive', text: 'Tidak Aktif' },
        { value: 'freeze', text: 'Dibekukan' },
        { value: 'cancel', text: 'Dibatalkan' },
      ],
      optionsUserLevel: [
        { value: 'regular', text: 'Reguler' },
        { value: 'juragan', text: 'Juragan' },
        { value: 'saudagar', text: 'Saudagar' },
      ],
      status: [],
      userLevel: [],
    }
  },
  computed: {
    params() {
      return {
        offset: this.offset,
        limit: this.limit,
        search: this.search,
        user_level: this.userLevel.join(','),
        status: this.status.join(','),
      }
    },
  },
  created() {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown_status_card' || bvEvent.componentId === 'dropdown_user_level') {
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown_status_card' || bvEvent.componentId === 'dropdown_user_level') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  mounted() {
    this.listCards()
  },
  methods: {
    async listCards() {
      this.loading = true
      this.offset = 0

      const url = '/komcards/api/v1/admin/card/list'
      await newAxiosIns.get(url, { params: this.params })
        .then(res => {
          const { data } = res.data
          const normalizeData = !isEmpty(data) ? data : []
          this.loading = false
          this.offset = normalizeData.length
          this.items = normalizeData
          if (normalizeData.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(() => {
          this.$toast_error({ message: 'Gagal load data' })
          this.loading = false
        })
    },
    getNextData() {
      if (!this.lastData) {
        this.loading = true

        const url = '/komcards/api/v1/admin/card/list'
        newAxiosIns
          .get(url, { params: this.params })
          .then(res => {
            const { data } = res.data
            const normalizeData = !isEmpty(data) ? data : []
            this.items.push(...normalizeData)
            this.offset += data.length
            this.loading = false
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(() => {
            this.loading = false
            this.$toast_error({ message: 'Gagal load data' })
          })
      }
    },
    searchData: _.debounce(function search() {
      this.offset = 0
      this.listCards()
    }, 1000),
    async onCopy(value) {
      navigator.clipboard.writeText(value)
      this.$toast_success({ message: `Card id ${value} berhasil di copy` })
    },
    onInfiniteScroll() {
      const table = document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 5
        && !this.loading
        && !this.lastData
      ) {
        this.getNextData()
      }
    },
    mappingStatus(value) {
      const data = {
        active: 'Aktif',
        inactive: 'Tidak Aktif',
        pending: 'Pending',
        freeze: 'Dibekukan',
        cancel: 'Dibatalkan',
      }
      return data[value]
    },
    mappingColor(value) {
      const data = {
        active: 'bg-[#34A770]',
        inactive: 'bg-[#E31A1A]',
        pending: 'bg-[#c2c2c2]',
        freeze: 'bg-[#828282]',
        cancel: 'bg-[#828282]',
      }
      return data[value]
    },
    onResetFilter() {
      this.offset = 0
      this.userLevel = []
      this.status = []
      this.listCards()
    },
    onApplyFilter() {
      this.offset = 0
      this.listCards()
    },
  },
}
</script>

<style scoped>
.b-dropdown-form {
  padding: 0.25rem 0.25rem !important;
}
</style>
